import { ReactElement } from 'react';

type Props = {
  title: string | undefined;
  subtitle?: string;
};

export const SearchTitleHeader = ({ title = '', subtitle = '' }: Props): ReactElement => {
  return (
    <div className="mb-3 flex w-full space-x-2 border-b border-solid border-gray-400 p-2">
      <span className="font-bold leading-5">{title ? title : ''}</span>
      <span className="leading-5">{subtitle}</span>
    </div>
  );
};
